<template>
  <q-card
    flat bordered
  >
    <q-card-section
        class="q-pa-sm row justify-between items-center text-bold"
    >
       Today's Summary
    </q-card-section>
    <q-separator />
    <q-card-section>
      <div class="row q-gutter-sm">
        <div class="col">
          <app-clock-card
            class="shadow-8"
            icon="alarm_on"
            color="white"
            label="IN TIME"
            :value="hoursFormatAsTimer(todayData.workHours)"
            iconColor="brand9"
            labelColor="brand9"
            valueColor="primary"
          />
        </div>
        <div class="col">
          <app-clock-card
            icon="alarm_off"
            class="shadow-8"
            color="white"
            label="BREAK"
            :value="hoursFormatAsTimer(todayData.breakHours)"
            iconColor="brand9"
            labelColor="brand9"
            valueColor="brand3"
          />
        </div>
        <div class="col">
          <app-clock-card
            icon="schedule"
            class="shadow-8"
            color="white"
            label="TOTAL TIME"
            :value="hoursFormatAsTimer(todayData.workHours+todayData.breakHours)"
            iconColor="brand9"
            labelColor="brand9"
            valueColor="primary"
          />
        </div>
      </div>
    </q-card-section>
  </q-card>

</template>
<script>
  import graphql from '@client/graphql';
  import AppClockCard from './clock-card';

  export default {
    name: 'AppClockTodaySummary',
    components: {
      AppClockCard
    },
    apollo: {
      todaySummary: {
        query: graphql.queries.todaySummary,
        watchLoading(isLoading) {
          this.isLoading = isLoading;
        },
        result(result) {
          this.todayData = result?.data?.todaySummary;
        }
      }
    },
    data() {
      return {
        isLoading: false,
        todayData: {
          workHours: 0,
          breakHours: 0
        }
      };
    },
    methods: {
      hoursFormatAsTimer(hours) {
       return new Date(hours * 60 * 60 * 1000).toISOString().substring(11, 19);
      }
    }
  };
</script>
<style lang="scss">
</style>
